<template>
  <span>
    <v-menu offset-y>
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              color="primary"
              small
              depressed
              text
              v-bind="attrs"
              v-on="{ ...tooltip, ...menu }"
              class="px-0"
            >
              <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <span>More Reports</span>
        </v-tooltip>
      </template>

      <v-list>
        <v-list-item
          v-for="report in sortedReportTypes"
          :key="report.id"
          @click="activateDialog(report)"
          ><v-icon class="mr-2">{{ report.icon }}</v-icon
          >{{ report.name }}
        </v-list-item>
        <v-list-item @click="downloadAppointmentsByRequestedDate"
          ><v-icon class="mr-2">mdi-file-table-outline</v-icon>Appointments By
          Requested Date</v-list-item
        >
      </v-list>
    </v-menu>
    <v-dialog v-model="dialog" width="400px">
      <v-card v-if="dialog">
        <validation-observer v-slot="{ invalid }" ref="form">
          <v-card-title>{{ selectedReport.name }}</v-card-title>
          <v-card-text>
            <date-picker
              v-if="selectedReport.id !== 6"
              :value="selectedDate"
              :field="{ label: 'Date' }"
              @fieldChange="selectedDate = $event"
              :validations="{ required: true }"
            ></date-picker>
            <date-picker
              v-if="selectedReport.id === 6"
              :value="selectedDate"
              :field="{ label: 'Start' }"
              @fieldChange="selectedDate = $event"
              :validations="{ required: true }"
            ></date-picker>
            <date-picker
              v-if="selectedReport.id === 6"
              :value="selectedEnd"
              :field="{ label: 'End' }"
              @fieldChange="selectedEnd = $event"
              :validations="{ required: true }"
            ></date-picker>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text :disabled="loading" @click="clear">
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              outlined
              :dark="!invalid && !loading"
              :disabled="invalid || loading"
              @click="download"
              >Download
            </v-btn>
          </v-card-actions>
        </validation-observer>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import { formatDate } from "../../utils/format-utils";
import { downloadFile } from "../../utils/download-utils";
export default {
  data() {
    return {
      dialog: false,
      selectedReport: "",
      selectedDate: "",
      selectedEnd: "",
      loading: false,
      reportTypes: [
        {
          id: 1,
          name: "Sign-in Sheet",
          icon: "mdi-file-clock-outline",
          path: "generateIDEPSignInSheet",
        },
        {
          id: 2,
          name: "Assessment Certifications",
          icon: "mdi-folder-zip-outline",
          path: "generateIDEPAssessmentCertifications",
        },
        {
          id: 3,
          name: "Scheduled Report",
          icon: "mdi-file-chart-outline",
          path: "generateIDEPScheduledAppointmentsReport",
        },
        {
          id: 4,
          name: "Recommendation Report",
          icon: "mdi-file-check-outline",
          path: "generateIDEPAppointmentsWithRecommendationsReport",
        },
        {
          id: 5,
          name: "Assessment Recommendations and Denials",
          icon: "mdi-folder-zip-outline",
          path: "generateIDEPAssessmentRecommendationsAndDenials",
        },
        {
          id: 6,
          name: "Recommendation Report (date range)",
          icon: "mdi-file-multiple-outline",
          path: "generateIDEPAppointmentsWithRecommendationsReportForDateRange",
        },
      ],
    };
  },
  computed: {
    sortedReportTypes() {
      return this.reportTypes.sort((a, b) => a.id - b.id);
    },
  },
  methods: {
    activateDialog(report) {
      this.selectedReport = report;

      // default dates based on report type
      const today = new Date();
      switch (report.id) {
        case 1:
        case 2:
          this.selectedDate = today;
          break;
        case 3:
          this.selectedDate = this.addBusinessDays(today, 3);
          break;
        case 4:
        case 5:
          this.selectedDate = this.addBusinessDays(today, -1);
          break;
        default:
          this.selectedDate = "";
      }
      this.dialog = true;
    },
    addBusinessDays(start, addDays) {
      var date = new Date(start.getTime());
      while (addDays != 0) {
        date = new Date(date.setDate(date.getDate() + Math.sign(addDays)));
        if (date.getDay() !== 0 && date.getDay() !== 6) {
          addDays -= Math.sign(addDays);
        }
      }
      return date;
    },
    async download() {
      this.loading = true;

      var url =
        process.env.VUE_APP_OMNI_BASE_URL +
        "/api/mta/" +
        this.selectedReport.path +
        "?date=" +
        formatDate(this.selectedDate);
      if (this.selectedReport.id == 6) {
        url += "&end=" + formatDate(this.selectedEnd);
      }
      window.open(url);

      this.loading = false;
      this.clear();
    },
    async downloadAppointmentsByRequestedDate() {
      this.loading = true;
      var response = await this.$store.dispatch(
        "appointmentsModule/exportIDEPAppointmentsByRequestedDate"
      );
      if (response) {
        await downloadFile(response, "Appointments By Requested Date.csv");
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Oops! Something went wrong. Please try again later."
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.loading = false;
    },
    clear() {
      this.$refs.form.reset();
      this.dialog = false;
      this.selectedReport = "";
      this.selectedDate = "";
      this.selectedEnd = "";
    },
  },
};
</script>
